var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8F8F8F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.334,
    d: "m.668 7.337 6.67-6.67m0 0H.668m6.67 0v6.67"
  })));
};
export default SvgArrowTopRight;